// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .app-main-inner-row .el-form .volume-col .el-col {\n  margin-top: 0;\n}\n.goodsTable .el-form-item {\n  margin: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
